<app-periodo-dashboard [periodoInicial]="periodoInicial" prefijo="riesgos" (cambio)="onPeriodo($event)">
  <div meta class="tickets-toolbar__meta">
    <span>{{ totalCortes }} cortes de seguimiento</span>
    <strong>{{ rangoInicio | date:'dd/MM/yyyy' }} - {{ rangoFin | date:'dd/MM/yyyy' }}</strong>
  </div>
</app-periodo-dashboard>

<div class="tickets-alert" *ngIf="errorCarga">
  {{ errorCarga }}
</div>

<section class="tickets-kpis" aria-label="Indicadores principales de riesgos">
  <!-- Una tarjeta con ruta es un enlace (hoy, «Propuestas pendientes» ->
       «Cambios por aprobar»): se abre con clic o con Enter. -->
  <article class="ticket-kpi" *ngFor="let kpi of kpis" [ngClass]="kpi.className"
           [class.ticket-kpi--enlace]="!!kpi.ruta"
           [attr.role]="kpi.ruta ? 'link' : null"
           [attr.tabindex]="kpi.ruta ? 0 : null"
           [attr.aria-label]="kpi.ruta ? kpi.label + ': ' + kpi.value + '. Abrir Cambios por aprobar' : null"
           (click)="abrirKpi(kpi)" (keydown.enter)="abrirKpi(kpi)">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && kpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Foto de hoy</span>
        <h2>Riesgos por severidad inicial</h2>
      </div>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalBandas }}</strong>
          <span>Valorados</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of bandaItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }} ({{ getBandaPercent(item) }}%)</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && errorRiesgos">
      No se pudo consultar los riesgos de proceso.
    </div>

    <div class="tickets-empty" *ngIf="!cargando && !errorRiesgos && totalBandas === 0">
      No hay riesgos de proceso activos con valoracion inicial en matrices activas.
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Foto de hoy</span>
        <h2>Riesgos y activos por matriz</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="matrizItems.length > 0; else emptyMatricesTpl">
      <div class="tickets-bar" *ngFor="let item of matrizItems">
        <div class="tickets-bar__row">
          <span>{{ item.nombre }}</span>
          <strong>{{ item.riesgos }} riesgos</strong>
        </div>
        <div class="tickets-bar__track">
          <span class="riesgos-bar--riesgos" [ngStyle]="getMatrizBarStyle(item.riesgos)"></span>
        </div>
        <div class="tickets-bar__track riesgos-track--activos">
          <span class="riesgos-bar--activos" [ngStyle]="getMatrizBarStyle(item.activos)"></span>
        </div>
        <small>{{ item.activos }} activos IA</small>
      </div>
    </div>

    <div class="riesgos-leyenda" *ngIf="matrizItems.length > 0">
      <span><i class="riesgos-bar--riesgos"></i>Riesgos de proceso</span>
      <span><i class="riesgos-bar--activos"></i>Activos IA</span>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Foto de hoy</span>
        <h2>Probabilidad x impacto inicial</h2>
      </div>
    </div>

    <div class="riesgos-heat" *ngIf="totalBandas > 0; else emptyCalorTpl">
      <div class="riesgos-heat__row" *ngFor="let fila of filasCalor">
        <span class="riesgos-heat__label" [title]="'Probabilidad ' + fila.prob">P{{ fila.prob }}</span>
        <div
          class="riesgos-heat__cell"
          *ngFor="let celda of fila.celdas"
          [ngClass]="getCeldaClass(celda)"
          [title]="'Probabilidad ' + celda.prob + ' x impacto ' + celda.impacto + ' = ' + celda.severidad + ' (' + celda.banda + ')'">
          <strong>{{ celda.total }}</strong>
          <small>{{ celda.severidad }}</small>
        </div>
      </div>
      <div class="riesgos-heat__row riesgos-heat__row--eje">
        <span class="riesgos-heat__label"></span>
        <span class="riesgos-heat__label" *ngFor="let impacto of impactos" [title]="'Impacto ' + impacto">I{{ impacto }}</span>
      </div>
      <div class="riesgos-leyenda">
        <span *ngFor="let item of bandaItems"><i [style.background]="item.color"></i>{{ item.nombre }}</span>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Periodo</span>
        <h2>Cortes de seguimiento por mes</h2>
        <small class="riesgos-alcance">Ultimos 8 meses del periodo</small>
      </div>
    </div>

    <div class="incident-months" *ngIf="mesItems.length > 0; else emptyMesesTpl">
      <div class="incident-month" *ngFor="let item of mesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getMesBarStyle(item, i)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>
</section>

<section class="tickets-card tickets-card--table">
  <div class="tickets-card__header">
    <div>
      <span>Periodo</span>
      <h2>Ultimos cortes de seguimiento</h2>
    </div>
    <button type="button" class="tickets-link-button" *ngIf="puedeAbrir" (click)="abrirGestion()">Ver todos</button>
  </div>

  <div class="tickets-table-wrap" *ngIf="cortesRecientes.length > 0; else emptyCortesTpl">
    <table class="tickets-table">
      <thead>
        <tr>
          <th>Tipo</th>
          <th>Folio</th>
          <th>Matriz</th>
          <th>Fecha</th>
          <th>Resultado</th>
          <th>Usuario</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let corte of cortesRecientes">
          <td>
            <span class="ticket-status" [ngClass]="getTipoClass(corte)">{{ corte.tipo || 'Riesgo' }}</span>
          </td>
          <td class="tickets-table__id">{{ corte.consecutivo || 'S/F' }}</td>
          <td>{{ corte.matriz || 'Sin matriz' }}</td>
          <td>{{ corte.fecha | date:'dd/MM/yyyy' }}</td>
          <td class="riesgos-resultado">
            <span class="ticket-status ticket-status--sin" *ngIf="corte.pendiente; else resultadoTpl">Pendiente</span>
            <ng-template #resultadoTpl>{{ corte.resultado || 'Sin resultado' }}</ng-template>
          </td>
          <td>{{ corte.usuario || 'N/D' }}</td>
          <td>
            <button
              type="button"
              class="tickets-table__action"
              *ngIf="puedeAbrirCorte(corte)"
              (click)="abrirCorte(corte)"
              aria-label="Abrir matriz">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<ng-template #emptyMatricesTpl>
  <div class="tickets-empty">No hay matrices activas para mostrar.</div>
</ng-template>

<ng-template #emptyCalorTpl>
  <div class="tickets-empty">No hay riesgos de proceso para el mapa de calor.</div>
</ng-template>

<ng-template #emptyMesesTpl>
  <div class="tickets-empty">No hay cortes de seguimiento en el periodo.</div>
</ng-template>

<ng-template #emptyCortesTpl>
  <div class="tickets-empty">No hay cortes de seguimiento en el periodo.</div>
</ng-template>
